import { useDateQueryParam } from '@occc-app/routes/Transactions/TransactionsListPage/hooks';
import {
  deletePaginationParams,
  usePaginationParams as usePaginationParamsImported,
} from '@occc-app/hooks/usePaginationParams';
import { useQueryParam } from '@occc-app/hooks/useQueryParam';

import { MembershipActivityType, PointChangeTypeFilterValue } from './membership-activity.types';
import { isPointChangeTypeFilterValue } from './membership-activity.utils';

import {
  TRANSACTIONS_BEFORE_PARAM,
  TRANSACTIONS_AFTER_PARAM,
  TRANSACTIONS_START_DATE_PARAM,
  TRANSACTIONS_END_DATE_PARAM,
  TRANSACTIONS_TYPE_PARAM,
  TRANSACTIONS_POINT_CHANGE_TYPE_PARAM,
} from '../../../constants';

export const useStartDateFilter = () =>
  useDateQueryParam(
    TRANSACTIONS_START_DATE_PARAM,
    TRANSACTIONS_BEFORE_PARAM,
    TRANSACTIONS_AFTER_PARAM,
  );

export const useEndDateFilter = () =>
  useDateQueryParam(
    TRANSACTIONS_END_DATE_PARAM,
    TRANSACTIONS_BEFORE_PARAM,
    TRANSACTIONS_AFTER_PARAM,
  );

export const useTypeFilter = () => {
  return useQueryParam<MembershipActivityType>(
    (searchParams) => {
      const type = searchParams.get(TRANSACTIONS_TYPE_PARAM) || 'any';
      return type as MembershipActivityType;
    },
    (value, searchParams) => {
      if (value) {
        searchParams.set(TRANSACTIONS_TYPE_PARAM, value);
      } else {
        searchParams.delete(TRANSACTIONS_TYPE_PARAM);
      }

      deletePaginationParams(searchParams);
    },
  );
};

export const usePointChangeTypeFilter = () => {
  return useQueryParam<PointChangeTypeFilterValue>(
    (searchParams) => {
      const pointChangeType = searchParams.get(TRANSACTIONS_POINT_CHANGE_TYPE_PARAM);
      if (pointChangeType && isPointChangeTypeFilterValue(pointChangeType)) {
        return pointChangeType;
      }
      return 'any';
    },
    (value, searchParams) => {
      if (value) {
        searchParams.set(TRANSACTIONS_POINT_CHANGE_TYPE_PARAM, value);
      } else {
        searchParams.delete(TRANSACTIONS_POINT_CHANGE_TYPE_PARAM);
      }

      deletePaginationParams(searchParams);
    },
  );
};

export const usePaginationParams = () =>
  usePaginationParamsImported({
    beforeParamName: TRANSACTIONS_BEFORE_PARAM,
    afterParamName: TRANSACTIONS_AFTER_PARAM,
  });
